module.exports = __webpack_public_path__ + "static/media/source-sans-pro-semibold.1cb8e94f.woff";